// From https://www.unicode.org/cldr/cldr-aux/charts/28/verify/dates/ur.html

const formatRelativeLocale = {
  lastWeek: "'گزشتہ' eeee p 'بعد دوپہر'",
  yesterday: "'گزشتہ کل' p 'بعد دوپہر'",
  today: "'آج' p 'بعد دوپہر'",
  tomorrow: "'آئندہ کل' p 'بعد دوپہر'",
  nextWeek: "'اگلے' eeee p 'بعد دوپہر'",
  other: 'P',
};

export const formatRelative = (token: keyof typeof formatRelativeLocale): string =>
  formatRelativeLocale[token];
